const color = [
    'AliceBlue', 'AntiqueWhite', 'Aqua', 'Aquamarine', 'Azure',
    'Beige', 'Bisque', 'Black', 'BlanchedAlmond', 'Blue',
    'BlueViolet', 'Brown', 'BurlyWood', 'CadetBlue', 'Chartreuse',
    'Chocolate', 'Coral', 'CornflowerBlue', 'Cornsilk', 'Crimson',
    'Cyan', 'DarkBlue', 'DarkCyan', 'DarkGoldenRod', 'DarkGray',
    'DarkGrey', 'DarkGreen', 'DarkKhaki', 'DarkMagenta',
    'DarkOliveGreen', 'Darkorange', 'DarkOrchid', 'DarkRed',
    'DarkSalmon', 'DarkSeaGreen', 'DarkSlateBlue', 'DarkSlateGray',
    'DarkSlateGrey', 'DarkTurquoise', 'DarkViolet', 'DeepPink',
    'DeepSkyBlue', 'DimGray', 'DimGrey', 'DodgerBlue', 'FireBrick',
    'FloralWhite', 'ForestGreen', 'Fuchsia', 'Gainsboro',
    'GhostWhite', 'Gold', 'GoldenRod', 'Gray', 'Grey', 'Green',
    'GreenYellow', 'HoneyDew', 'HotPink', 'IndianRed', 'Indigo',
    'Ivory', 'Khaki', 'Lavender', 'LavenderBlush', 'LawnGreen',
    'LemonChiffon', 'LightBlue', 'LightCoral', 'LightCyan',
    'LightGoldenRodYellow', 'LightGray', 'LightGrey', 'LightGreen',
    'LightPink', 'LightSalmon', 'LightSeaGreen', 'LightSkyBlue',
    'LightSlateGray', 'LightSlateGrey', 'LightSteelBlue', 'LightYellow',
    'Lime', 'LimeGreen', 'Linen', 'Magenta', 'Maroon',
    'MediumAquaMarine', 'MediumBlue', 'MediumOrchid', 'MediumPurple',
    'MediumSeaGreen', 'MediumSlateBlue', 'MediumSpringGreen',
    'MediumTurquoise', 'MediumVioletRed', 'MidnightBlue', 'MintCream',
    'MistyRose', 'Moccasin', 'NavajoWhite', 'Navy', 'OldLace', 'Olive',
    'OliveDrab', 'Orange', 'OrangeRed', 'Orchid', 'PaleGoldenRod',
    'PaleGreen', 'PaleTurquoise', 'PaleVioletRed', 'PapayaWhip',
    'PeachPuff', 'Peru', 'Pink', 'Plum', 'PowderBlue', 'Purple', 'Red',
    'RosyBrown', 'RoyalBlue', 'SaddleBrown', 'Salmon', 'SandyBrown',
    'SeaGreen', 'SeaShell', 'Sienna', 'Silver', 'SkyBlue', 'SlateBlue',
    'SlateGray', 'SlateGrey', 'Snow', 'SpringGreen', 'SteelBlue', 'Tan',
    'Teal', 'Thistle', 'Tomato', 'Turquoise', 'Violet', 'Wheat', 'White',
    'WhiteSmoke', 'Yellow', 'YellowGreen', 'transparent'
];
const backgroundAttachments = ['scroll','fixed','local','initial'];
const backgroundOrigins = ['padding-box','border-box','content-box'];
const backgroundClips = ['padding-box','border-box','content-box'];
const digitRegex = '(?:\\d+(?:\\.\\d+)?(?:[A-z]{2}|%)?)';
const rules = {
    //bg-color
    colorNamed: new RegExp(`(${color.join('|')})`,'i'),
    colorHex: /(#[0-9A-Fa-f]{3,8})/i,
    colorRgbHsl: /(rgb|hsl)\((\d{0,3}%?),(\d{0,3}%?),(\d{0,3}%?)\)/i,
    colorRgbaHsla: /(rgba|hsla)\((\d{0,3}%?),(\d{0,3}%?),(\d{0,3}%?),(\d(?:\.\d+)?)\)/i,
    //bg-image
    image: /url\((.*?)\)|(none)/i,
    //bg-position
    position: new RegExp(`((?:\\s*(?:left|right|center|top|bottom)){1,2})|(?:(${digitRegex})(?:\\s+(${digitRegex}))?)`,'i'),
    //bg-size
    size: new RegExp(`\\/?(?:(cover|contain|initial)|(?:(${digitRegex}|auto)(?:\\s+(${digitRegex}|auto))?))`),
    //bg-repeat
    repeat: /(repeat|repeat-x|repeat-y|no-repeat)/i,
    //bg-origin
    origin: new RegExp(`(${backgroundOrigins.join('|')})`,'i'),
    //bg-clip
    clip: new RegExp(`(${backgroundClips.join('|')})`,'i'),
    //bg-attachment
    attachment: new RegExp(`(${backgroundAttachments.join('|')})`,'i'),
};
/**
 * https://www.w3schools.com/cssref/css3_pr_background.asp
 * background: bg-color bg-image position/bg-size bg-repeat bg-origin bg-clip bg-attachment initial|inherit;
 */
export default class BackgroundPropertyParser {
    static defaults = {
        color: [],
        image: [],
        position: [],
        size: [],
        repeat: [],
        origin: [],
        clip: [],
        attachment: [],
        error: false,
    };
    constructor(property) {
        if(property) {
            this.property = property;
        }
    }
    set property(value) {
        Object.assign(this, BackgroundPropertyParser.defaults);
        this.$property = value;
        this.parseProgress = value;
        this.parse();
    }
    get property() {
        return this.$property;
    }

    clearImage() {
        this.image.splice(0);
        this.position.splice(0);
        this.size.splice(0);
        this.repeat.splice(0);
        this.origin.splice(0);
        this.clip.splice(0);
        this.attachment.splice(0);
        this.parseProgress = '';
        this.$property = '';
    }

    parseRule(regexp) {
        let match = [];
        this.parseProgress = this.parseProgress.replace(regexp, (matchedSubstring, ...p)=>{
            match = [...p.slice(0, -2)];
            return '';
        }).trim(); //trim text
        return match;
    }

    parseRuleSet(rules) {
        let result = [];
        rules.find(rule => (result = this.parseRule(rule)).length !== 0);
        return result;
    }

    parseColor(){
        let color = this.parseRuleSet([
            rules.colorNamed,
            rules.colorHex,
            rules.colorRgbHsl,
            rules.colorRgbaHsla
        ]);
        return color;
    }

    parseImage() {
        return this.parseRule(rules.image).filter(r => r);
    }

    parsePosition() {
        let position = this.parseRule(rules.position);
        if(position && position[0]) {
            position = position[0].split(' ');
            if(position.length === 1) {
                position.push('center');
            }
        } else if(position.length > 1) {
            position = position.splice(1).map(p => p !== undefined ? p : '50%');
        }
        return position;
    }

    parseSize() {
        let size = this.parseRule(rules.size);
        if(size.length && size[0]) {
            size = size.splice(0,1);
        } else if(size.length > 1) {
            size = size.splice(1).map(p => p !== undefined ? p : 'auto');
        }
        return size;
    }

    parseRepeat() {
        return this.parseRule(rules.repeat);
    }
    parseClip() {
        return this.parseRule(rules.clip);
    }
    parseOrigin() {
        return this.parseRule(rules.origin);
    }
    parseAttachment() {
        const attachment = this.parseRule(rules.attachment);
        if(attachment && attachment[0] === 'initial')
            return [];
        return attachment;
    }

    build() {
        let shorthand = [];
        if(this.color.length) {
            if(this.color.length === 1) {
                shorthand.push(this.color[0]);
            } else if(color.length >= 4) {
                shorthand.push(`${this.color[0]}(${this.color.slice(1).join(',')})`);
            }
        }
        if(this.image.length && this.image[0] !== 'none') {
            shorthand.push(`url(${this.image[0]})`);
        }
        if(this.position.length || this.size.length) {
            let p = (this.position.length ? this.position : ['center', 'center']).join(' ') + ((this.size.length) ? '/' : '') + this.size.join(' ');
            shorthand.push(p)
        }
        if(this.repeat.length) {
            shorthand.push(this.repeat[0]);
        }
        if(this.origin.length) {
            shorthand.push(this.origin[0]);
        }
        if(this.clip.length) {
            shorthand.push(this.clip[0]);
        }
        if(this.attachment.length && this.attachment[0] !== 'initial') {
            shorthand.push(`${this.attachment[0]}`);
        }
        return shorthand.join(' ');
    }

    parse() {
        this.color = this.parseColor();
        this.image = this.parseImage();
        this.position = this.parsePosition();
        this.size = this.parseSize();
        this.repeat = this.parseRepeat();
        this.origin = this.parseOrigin();
        this.clip = this.parseClip();
        this.attachment = this.parseAttachment();
        this.error = this.parseProgress !== '';
    }
}


// WEBPACK FOOTER //
// ./lib/css-property-parser/BackgroundProperyParser.js